import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-label-email-verify', {
  mixins: [eventListenerMixin],

  connected() {
    this.label = this.querySelector('.label');
    this.dialog = this.querySelector('tr-dialog');
    this.listenTo(this.label, 'click', () => this.dialog.open());
  },

  disconnected() {
    this.stopListening();
  },
});
